import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LegalPage } from "./components/LegalPage";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Examples } from "./components/Examples";
import { PlantillasShowcase } from "./components/PlantillasShowcase";
import { Differential } from "./components/Differential";
import { PanelMockup } from "./components/PanelMockup";
import { HowItWorks } from "./components/HowItWorks";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { InvitationDemo } from "./components/InvitationDemo";
import { demos, demoList } from "./data/demos";
import PlantillasPage from "./pages/PlantillasPage";
import Seo from "./seo/Seo";

function Home() {
  const [demoKey, setDemoKey] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const lenis = window.__lenis;
    if (!lenis) return;
    if (demoKey) lenis.stop();
    else lenis.start();
  }, [demoKey]);

  const cycleDemo = () => {
    const idx = demoList.findIndex((d) => d.key === demoKey);
    setDemoKey(demoList[(idx + 1) % demoList.length].key);
  };

  return (
    <div className="min-h-screen bg-[#FAFBFD] text-slate-900 antialiased">
      <Toaster position="bottom-center" richColors />
      <Navbar onOpenDemo={setDemoKey} />
      <main>
        <Hero onOpenDemo={setDemoKey} />
        <Marquee />
        <Examples onOpenDemo={setDemoKey} />
        <PlantillasShowcase />
        <Differential />
        <PanelMockup />
        <HowItWorks />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <InvitationDemo
        demoKey={demoKey ? demos[demoKey] : null}
        onClose={() => setDemoKey(null)}
        onSwitch={cycleDemo}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Seo />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/politica-de-privacidad" element={<LegalPage kind="privacy" />} />
        <Route path="/condiciones-de-servicio" element={<LegalPage kind="terms" />} />
        <Route path="/plantillas/*" element={<PlantillasPage />} />
        <Route path="/terminos-de-servicio" element={<Navigate to="/condiciones-de-servicio/" replace />} />
        <Route path="/eliminar-datos" element={<Navigate to="/politica-de-privacidad/#eliminacion" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
